@charset "UTF-8";

/* src/app/warehousing/pages/assistant/assistant.component.scss */
.assistant-answer {
  line-height: 1.5;
}
.assistant-run {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  margin-bottom: 0.75rem;
}
.assistant-run:last-child {
  margin-bottom: 0;
}
.assistant-question {
  overflow-wrap: anywhere;
}
.assistant-tools .badge {
  font-weight: normal;
}
.compactAssistant {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.compactPanel {
  padding: 0;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #eef2f6;
}
.compactPanel:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.compactHeader {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: #1e293b;
}
.assistant-proposal {
  background: #fef9f0;
  border: 1px solid #f3ddb0;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem;
}
.assistant-proposal-diff {
  width: 100%;
  font-size: 0.85rem;
}
.assistant-proposal-diff td {
  padding: 0.15rem 0.5rem 0.15rem 0;
  vertical-align: top;
}
.assistant-proposal-field {
  color: #64748b;
  font-weight: 600;
  white-space: nowrap;
}
.assistant-proposal-old {
  color: #94a3b8;
  text-decoration: line-through;
}
.assistant-proposal-new {
  color: #1e293b;
  font-weight: 600;
}
/*# sourceMappingURL=assistant.component.css.map */
